//Third party libraries

//Custom components
import Button from '@/components/UI/Button';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';
import Indebtedness from './Indebtedness';
import Tenancy from './Tenancy';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function FinancialInformation() {
  const { setCurrentStep } = useApplicationFormContext();

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>Financial Information</h3>
        <div className='flex flex-col gap-10'>
          <Indebtedness />
          <Tenancy />
        </div>
        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
          <Button label='Next' btnStyle='primary' type='button' onClick={() => setCurrentStep((prev) => prev + 1)} />
        </div>
      </div>
    </div>
  );
}
